function ReportTypes({ types, selectedType, fn }) {
  return (
    <>
      <div className='report-type-wrapper mx-auto' style={{ gap: '2rem' }}>
        {types?.map((type) => (
          <div
            key={type.id}
            onClick={() => fn(type.id)}
            style={{
              gap: '1.5rem',
            }}
            className={`${
              selectedType === type.id ? 'selected-report-border' : 'border'
            } py-4 d-flex flex-column align-items-center w-100 report-type-container`}
          >
            {type.icon}
            <div className='text-center' style={{ maxWidth: '85%' }}>
              <h4>{type.title}</h4>
              <p>{type.description}</p>
            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default ReportTypes
